<template>
    <div>
        <b-button v-b-popover.hover.bottom="'Add to cart'" variant="outline-primary" class="mx-2 img-icon img-icon-cart-add-9" size="sm"
                  @click="addToCart()" v-if="!addedInCart"></b-button>
        <b-button v-b-popover.hover.bottom="'Remove from cart'" variant="outline-danger" class="mx-2 img-icon img-icon-cart-remove-9" size="sm"
                  @click="removeFromCart()" v-if="addedInCart"></b-button>
    </div>
</template>

<script>

import { EntityId } from '../../../protobuf/general_pb';

export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    addedInCart() {
      let id = '';
      if (this.entity.checksum) {
        const entityId = new EntityId();
        entityId.setSize(this.entity.size);
        entityId.setChecksum(this.entity.checksum);
        id = entityId.toString();
      } else {
        id = this.entity.jobId;
      }
      const cartItems = this.$store.getters['datacart/cartItems'];
      for (let index = 0; index < cartItems.length; index += 1) {
        const cartItem = cartItems[index];
        if (cartItem.itemType === 'job' && cartItem.id === id) {
          return true;
        }
        if (cartItem.itemType === 'entity' && cartItem.id.toString() === id) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    addToCart() {
      this.$store.dispatch('datacart/addToCart', this.entity);
    },
    removeFromCart() {
      let itemId = '';
      if (this.entity.checksum) {
        const entityId = new EntityId();
        entityId.setSize(this.entity.size);
        entityId.setChecksum(this.entity.checksum);
        itemId = entityId.toString();
      } else {
        itemId = this.entity.jobId;
      }
      this.$store.dispatch('datacart/removeFromCart', { id: itemId });
    },
  },
};
</script>
<style scoped>
.addRemoveBtn{
  display: block;
  position: relative;
  top: 30px;
  right: 15px;
  z-index: 1;
  left: 421px;
}
</style>
